<template>
	<div class="contents">
		<div
			v-if="hasImage"
			class="image"
			:class="{'border-white': !!icon}"
		>
			<img
				v-if="image"
				:alt="image"
				:src="image"
			>
			<Icon
				v-else-if="icon"
				class="text-white"
				:icon-name="icon"
				size="lg"
			/>
		</div>
		<div
			class="ml-2 flex-grow text-white"
		>
			{{ label }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
		},
		placeholder: {
			type: String,
		},
	},
	computed: {
		hasImage() {
			if (!this.item) {
				return true;
			}
			return this.item.icon || this.item.image;
		},
		image() {
			if (!this.item) {
				return false;
			}

			return this.item.image;
		},
		icon() {
			if (!this.item) {
				return 'users-wm';
			}
			return this.item.icon;
		},
		label() {
			return this.item?.label || this.placeholder || this.transUcfirst('analysis.select_athlete');
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.text-white {
	color: var(--color-white);
}

.image {
	width: 48px;
	height: 48px;
	background: var(--color-grey-800);
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;

	&.border-white {
		border: solid 1px var(--color-soft-white);
	}

	&.border-grey {
		border: solid 1px var(--color-grey-300);
	}

	img {
		width: 100%;
		height: 100%;
		border-radius: 50%;
		object-fit: cover;
	}
}
</style>
